import { splitPluginTextInputMessage } from "@markit/common.utils";
import { TextPluginOptions } from "@markit/common.types";
import { addAlpha, Colors } from "../../../../utils/colors";
import StandardBorderedContainer from "../../../Containers/StandardBorderedContainer";
import TextHoverButton from "../../../Buttons/TextHoverButton";

export type TextComposerSuggestionResult = {
  rewrittenText: string;
};

// Matches the same green used for recognized plugin tokens in the actual
// drafting textarea (InsertPluginTextInput.tsx) - no event/attachment context
// is available here, so this colors any known plugin token generically
// rather than only ones valid for the currently attached event.
const renderWithPluginHighlighting = (text: string) =>
  splitPluginTextInputMessage(text).map((word, index) => {
    const isPluginToken = TextPluginOptions.some((plugin) =>
      word.includes(plugin.name)
    );
    return (
      <span
        key={index}
        style={isPluginToken ? { color: Colors.GREEN2 } : undefined}
      >
        {word}
      </span>
    );
  });

type TextComposerSuggestionProps = {
  suggestion: TextComposerSuggestionResult;
  onUseThis: () => void;
  onKeepMine: () => void;
};

// Preview-only - never applied to the draft until "Apply" is pressed.
export const TextComposerSuggestion = (props: TextComposerSuggestionProps) => {
  const { suggestion, onUseThis, onKeepMine } = props;
  const { rewrittenText } = suggestion;

  return (
    <StandardBorderedContainer
      containerStyles={{
        borderRadius: 12,
        padding: 14,
        backgroundColor: addAlpha(Colors.PINK2, 0.1),
        border: `1px solid ${Colors.PINK2}`,
      }}
    >
      <div className="ColumnNormal" style={{ gap: 10 }}>
        <div className="AlignedRowSpaced">
          <span className="bodyMedium" style={{ color: Colors.PINK2 }}>
            Suggested Rewrite
          </span>
          <div className="AlignedRow" style={{ gap: 10 }}>
            <TextHoverButton
              text="Apply"
              onPress={onUseThis}
              textStyles={{
                color: Colors.BLACK,
                fontWeight: 600,
                fontSize: 14,
              }}
            />
            <TextHoverButton
              text="Close"
              onPress={onKeepMine}
              textStyles={{
                fontWeight: 600,
                fontSize: 14,
              }}
            />
          </div>
        </div>
        <div style={{ maxHeight: 140, overflowY: "auto" }}>
          <span className="bodyRegular" style={{ whiteSpace: "pre-line" }}>
            {renderWithPluginHighlighting(rewrittenText)}
          </span>
        </div>
      </div>
    </StandardBorderedContainer>
  );
};
